import React, { useEffect, useRef } from 'react';
import './ShowSelectedDealerBAS.scss';
import AnimatedButton from '../atoms/AnimatedButton/AnimatedButton';
import { getBasLabels, windowWidth } from '../../utils/commonUtils';
import { useAppUiStore } from '../../hooks/useStores';
import { onBASctaClick } from '../../analytics/analytics';

function ShowSelectedDealerBAS() {
  const labels = getBasLabels();
  const mapRef = useRef(null);
  const { uiStore } = useAppUiStore();

  useEffect(() => {
    // Initialize the map once the script is loaded
    const map = new window.google.maps.Map(mapRef.current, {
      zoom: 14,
      styles: [
        {
          stylers: [{ hue: '#00bbee' }, { saturation: -70 }],
        },
      ],
    });

    map.setCenter({
      lat: parseFloat(uiStore.dealerSelectionBAS.Latitude),
      lng: parseFloat(uiStore.dealerSelectionBAS.Longitude),
    }); // Set map center to first marker location
    const marker = new window.google.maps.Marker({
      position: {
        lat: parseFloat(uiStore.dealerSelectionBAS.Latitude),
        lng: parseFloat(uiStore.dealerSelectionBAS.Longitude),
      },
      map: map,
      animation: window.google.maps.Animation.DROP,
      title: uiStore.dealerSelectionBAS.Name, // Tooltip on hover
      icon: {
        url: '/assets/feature/genesis/buildandorder/assets/images/location-pin-black.svg', // Custom marker icon
        scaledSize: new window.google.maps.Size(50, 50), // Icon size
        labelOrigin: new window.google.maps.Point(25, 12), // Adjust label position (x, y)
      },
      label: {
        text: uiStore.dealerSelectionBAS.SortOrder,
        color: 'black',
        fontSize: '10px',
        fontWeight: 'bold',
      },
    });
  }, []);

  function redirectToBookService() {
    //Redirect to third party here
    if (uiStore.dealerSelectionBAS?.DMS?.DMSServiceURL) {
      window.location.assign(uiStore.dealerSelectionBAS?.DMS?.DMSServiceURL);
      console.log('Redirecting to third party service URL');
    }
    //Analytics change - on book now
    if (uiStore.dealerSelectionBAS.Name) onBASctaClick(uiStore.dealerSelectionBAS.Name);
  }

  function chooseAnotherDealer(e) {
    e.preventDefault();
    uiStore.updateDealerSelectionBAS(null);
  }

  return (
    <div className="show_selected_dealer">
      {windowWidth < 1200 && (
        <h2 className="dealer_heading">
          {labels.selectedDealerTitle}
          {` ${uiStore.dealerSelectionBAS.Name}`}
        </h2>
      )}
      <div className="map_container_result" ref={mapRef}></div>
      <div className="dealer_details">
        {windowWidth >= 1200 && (
          <h2 className="dealer_heading">
            {labels.selectedDealerTitle}
            {` ${uiStore.dealerSelectionBAS.Name}`}
          </h2>
        )}
        <div className="dealer_info">
          <div className="address_phone_mail">
            <div className="address_details">
              <div className="icon_label">
                <span className="icon-GENS_pin"></span>
                <span className="label">{labels.addressTitle}</span>
              </div>
              <div className="address">
                {`${uiStore.dealerSelectionBAS.ServiceAddressStreet.toLowerCase()}`} <br />{' '}
                {`${uiStore.dealerSelectionBAS.ServiceAddressCity.toLowerCase()}`}
              </div>
              <div className="address">{uiStore.dealerSelectionBAS.ServiceAddressPostalCode}</div>
              <div className="get_directions_container">
                <a
                  className="get-direction-link"
                  href={`https://www.google.com/maps?q=${uiStore.dealerSelectionBAS.Latitude},${uiStore.dealerSelectionBAS.Longitude}`}
                  target="_blank"
                  rel="noopener noreferrer">
                  {labels?.getDirections}
                </a>
              </div>
            </div>
            <div className="call_details">
              <span className="icon-GENS_phone"></span>
              <span className="phone">{uiStore.dealerSelectionBAS.Phone}</span>
            </div>
            <div className="mail_details">
              <span className="icon-GENS_email"></span>
              <span className="email">{uiStore.dealerSelectionBAS.ServiceEmail}</span>
            </div>
            <div className="choose_another_link">
              <a href="#" className="choose_another" onClick={chooseAnotherDealer}>
                {labels.anotherDistributorLinkTitle}
              </a>
            </div>
          </div>
          <div className="service_hours_container">
            <div className="service_icon_label">
              <span className="icon-GENS_store"></span>
              <span className="service_label">{labels.serviceHoursTitle}</span>
            </div>
            <div className="service_hours_container">
              {uiStore.dealerSelectionBAS.Hours.Service.Days.map((serviceHour) => {
                return (
                  <div className="day_item" key={serviceHour.Weekday}>
                    <span className="weekday">{serviceHour.Weekday.substring(0, 3)}</span>
                    <span className="hours">
                      {serviceHour.Start} {` - ${serviceHour.End}`}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="book_now_cta">
          {uiStore.dealerSelectionBAS?.DMS?.DMSServiceURL ? (
            <AnimatedButton
              text={labels.bookNowLabel}
              theme="white"
              clickHandler={redirectToBookService}
              activeClass="active"
            />
          ) : (
            <>
              <span className="no_service_url_message">{labels.noServiceUrlMessage}</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ShowSelectedDealerBAS;
